import { ActionFunction, ActionObject, Machine, State as BaseState } from 'xstate'

import { Event } from '@skinsoft/rxstate'

export type AuthenticateEvent = Event<'AUTHENTICATE'>
export type ChallengeEvent = Event<'CHALLENGE'>
export type DeauthenticateEvent = Event<'DEAUTHENTICATE'>
export type AuthenticateSSOEvent = Event<'CHALLENGE_SSO'>

export type AuthEvent = AuthenticateEvent | ChallengeEvent | DeauthenticateEvent | AuthenticateSSOEvent

export type AuthStateValue = 'authenticated' | 'challenging' | 'idle' | 'unauthenticated' | 'challengingSSO'

export interface AuthStateSchema {
    states: Record<AuthStateValue, {}>;
}

export interface AuthContext {
    userId?: string
    fromSSO?: boolean
}

export type State = BaseState<AuthContext, AuthEvent>;

interface Actions
    extends Record<
        string,
        ActionObject<AuthContext, AuthEvent> | ActionFunction<AuthContext, AuthEvent>
    > {
    beginChallenge(context: AuthContext, event: AuthEvent): void;
    clearStorage(context: AuthContext, event: AuthEvent): void;
    startUserPolling(context: AuthContext, event: AuthEvent): void;
    stopUserPolling(context: AuthContext, event: AuthEvent): void;
    storeUserId(context: AuthContext, event: AuthEvent): void;
    authenticateSSO(context: AuthContext, event: AuthEvent)
}

export function createMachine(actions: Actions) {
    return Machine<AuthContext, AuthStateSchema, AuthEvent>(
        {
            id: 'auth',
            initial: 'idle',
            states: {
                authenticated: {
                    entry: ['storeUserId', 'startUserPolling'],
                    on: {
                        DEAUTHENTICATE: 'unauthenticated',
                    },
                },
                challenging: {
                    entry: ['beginChallenge'],
                    on: {
                        AUTHENTICATE: 'authenticated',
                        DEAUTHENTICATE: 'unauthenticated',
                    },
                },
                idle: {
                    on: {
                        AUTHENTICATE: 'authenticated',
                        CHALLENGE: 'challenging',
                        DEAUTHENTICATE: 'unauthenticated',
                        CHALLENGE_SSO: 'challengingSSO',
                    },
                },
                challengingSSO: {
                    entry: ['authenticateSSO'],
                    on: {
                        AUTHENTICATE: 'authenticated',
                        DEAUTHENTICATE: 'unauthenticated',
                    },
                },
                unauthenticated: {
                    entry: ['stopUserPolling', 'clearStorage'],
                    on: {
                        CHALLENGE: 'challenging',
                    },
                },
            },
        },
        {
            actions,
        },
        {},
    );
}
